import { render, staticRenderFns } from "./DeliverableDepartments.vue?vue&type=template&id=c27ab2e2&"
import script from "./DeliverableDepartments.vue?vue&type=script&lang=js&"
export * from "./DeliverableDepartments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c27ab2e2')) {
      api.createRecord('c27ab2e2', component.options)
    } else {
      api.reload('c27ab2e2', component.options)
    }
    module.hot.accept("./DeliverableDepartments.vue?vue&type=template&id=c27ab2e2&", function () {
      api.rerender('c27ab2e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/DeliverableDepartments.vue"
export default component.exports